import React, { FC } from 'react'

import { DotContainer, IndicatorDot } from './styles'

interface DotIndicatorProps {
  currentSlide: number
  numberOfDots: number
}

const NewDotIndicators: FC<DotIndicatorProps> = ({
  currentSlide,
  numberOfDots,
}) => {
  const dotsArray = [...Array(numberOfDots).keys()]
  return (
    <DotContainer>
      {dotsArray.map((dot) => (
        <IndicatorDot
          active={dot === currentSlide}
          className="indicatorDot"
          key={`indicatorDot${dot}`}
        />
      ))}
    </DotContainer>
  )
}

export default NewDotIndicators
